/**
 * Normalizes a manually entered NFC card UID to canonical form:
 * lowercase hex with no separators (spaces, colons, hyphens removed).
 */
export function normalizeCardUid(raw: string): string {
  return (raw ?? '').trim().replace(/[\s:\-]/g, '').toLowerCase();
}
